import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Container } from "../components/Grid";
import API from "../utils/API";
import MusicBtn from "../components/SoundBtns/MusicBtn";
import "./New.css";

const characters = Array.from({ length: 10 }, (_, index) => {
  const id = index + 1;
  return { id, img: require("../images/option" + id + ".png"), path: "option" + id + "-4row.png" };
});

function formatCharacterName(value) {
  return value
    .toLowerCase()
    .replace(/(^|[\s-])([a-z])/g, (_, separator, letter) => separator + letter.toUpperCase());
}

function New() {
  const { id } = useParams();
  const history = useHistory();
  const [sprite, setSprite] = useState("");
  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [requestError, setRequestError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const nextErrors = {};
    if (!sprite) nextErrors.sprite = "Choose a character.";
    if (!name.trim()) nextErrors.name = "Enter a character name.";
    setErrors(nextErrors);
    setRequestError("");
    if (Object.keys(nextErrors).length) return;

    setLoading(true);
    try {
      const formattedName = formatCharacterName(name.trim());
      const response = await API.saveSprite({ sprite, name: formattedName }, id);
      if (response && response.ok === false) throw new Error("Request failed");
      history.push("/continue/" + id);
    } catch (error) {
      setRequestError("We could not start your adventure. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <main className="new-adventure-page">
        <MusicBtn />
        <header className="new-adventure-header">
          <p className="new-adventure-eyebrow"><span aria-hidden="true">✦</span> Begin a new chapter</p>
          <h1>Start a New Adventure</h1>
          <p>Choose a companion, give them a name, and step into the realm.</p>
        </header>
        {requestError && <p className="new-adventure-alert" role="alert">{requestError}</p>}
        <form className="newGame new-adventure-grid" aria-label="Create your character" noValidate onSubmit={handleSubmit}>
          <section className="character-picker" aria-labelledby="character-picker-title">
            <div className="section-heading">
              <p className="new-adventure-eyebrow">Your companion</p>
              <h2 id="character-picker-title">Choose a character</h2>
              <p>Every hero has a different way through the story.</p>
            </div>
            <fieldset aria-describedby={errors.sprite ? "sprite-error" : undefined}>
              <legend className="sr-only">Select a character</legend>
              <div className="character-grid">
                {characters.map((character) => <label className={"character-option" + (sprite === character.path ? " character-option--selected" : "")} key={character.id} htmlFor={"sprite-" + character.id}>
                  <img className="img-path" src={character.img} alt={"Character option " + character.id} />
                  <input id={"sprite-" + character.id} name="sprite" value={character.path} checked={sprite === character.path} onChange={(event) => setSprite(event.target.value)} type="radio" />
                  <span className="character-option__name">Character {character.id}</span>
                  <span className="character-option__check" aria-hidden="true">✦</span>
                </label>)}
              </div>
            </fieldset>
            {errors.sprite && <p id="sprite-error" className="new-adventure-error" role="alert">{errors.sprite}</p>}
          </section>

          <section className="name-panel" aria-labelledby="name-panel-title">
            <div className="name-panel__ornament" aria-hidden="true">✦</div>
            <p className="new-adventure-eyebrow">Name your hero</p>
            <h2 id="name-panel-title">Who will enter the story?</h2>
            <p className="name-panel__copy">Give your character a name worthy of the next chapter.</p>
            <label htmlFor="character-name">Character name</label>
            <input name="character" value={name} onChange={(event) => setName(formatCharacterName(event.target.value))} type="text" className="form-control special" id="character-name" placeholder="e.g. Ari Moonbeam" maxLength="40" required aria-describedby={errors.name ? "name-error" : "name-help"} />
            {errors.name ? <p id="name-error" className="new-adventure-error" role="alert">{errors.name}</p> : <p id="name-help" className="name-panel__hint">Each word will begin with a capital letter.</p>}
            <button className="btn new-adventure-submit" type="submit" disabled={loading}>{loading ? "Starting adventure…" : "Enter the Realm"}</button>
            <p className="name-panel__warning">Starting a new adventure overwrites any existing adventure.</p>
          </section>
        </form>
      </main>
    </Container>
  );
}

export default New;
